var map = {
	"./PendingSvg": "ec58",
	"./PendingSvg.vue": "ec58",
	"./ReferToSvg": "428c",
	"./ReferToSvg.vue": "428c",
	"./SelectEmployeeSvg": "2465",
	"./SelectEmployeeSvg.vue": "2465",
	"./WarningSvg": "1ef1",
	"./WarningSvg.vue": "1ef1",
	"./addSchedule.svg": "8c61",
	"./bug.svg": "c0e3",
	"./construction-worker.jpg": "2037",
	"./content-cut.png": "b20f",
	"./email-pattern.png": "2a21",
	"./happy-news.svg": "f719",
	"./login_work_time.svg": "611d",
	"./logo-alt.webp": "2ad3",
	"./logo-ecovie.png": "613d",
	"./logo-sangalli.png": "fc58",
	"./logo-viberto.png": "217f",
	"./logo.png": "cf05",
	"./noData.svg": "f5bf",
	"./operatori.png": "af41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";